import { getPurchaseMethod } from './getPurchaseMethod';

const Invoice = {
  getPurchaseMethod,
};
export { Invoice };
